import React from 'react';
import { ErrorLayout, MainLayout } from '@layouts';
import { getErrorContent } from '@libs';
import { getHelpSection } from '@modules/get-data';
import { HelpSectionPage } from '@sections/Help-Center-Sections';
import { ErrorContent } from '@components/Help-Center-Components';
import { ErrorConnection } from '@components/Help-Center-Components/error-connection';
import { PROCESSING_ITEMS, HELP_CENTER } from '@constants';
import * as actions from '@store/actions';

const HelpSection = ({ data }) => {
  return <HelpSectionPage data={data} section={data.slug} />;
};

HelpSection.getLayout = (page, { data, locale, statusCode, isDisconnect }) => {
  const { translations, query } = page.props;

  if (isDisconnect) {
    return (
      <ErrorLayout>
        <MainLayout>
          <ErrorConnection />
        </MainLayout>
      </ErrorLayout>
    );
  }
  if (statusCode) {
    const error = getErrorContent({ code: statusCode });

    return (
      <ErrorLayout title={translations.t(error.title)}>
        <MainLayout reqQuery={query}>
          <ErrorContent error={error} locale={locale} />
        </MainLayout>
      </ErrorLayout>
    );
  }

  const metaTitle = data.meta_title || `${translations.t('site.help.metaTitleTemplate.troubleshooting')}`;
  const metaDescription = data.meta_description || translations.t('site.help.metaDescriptionTemplate.troubleshooting');

  return (
    <MainLayout
      reqQuery={query}
      title={metaTitle}
      processing={PROCESSING_ITEMS.GET_HELP_SECTION}
      description={metaDescription}>
      {page}
    </MainLayout>
  );
};

HelpSection.getInitialProps = async ({ res, query, store }) => {
  const { category } = query;
  const { dispatch, getState } = store;
  const section = HELP_CENTER.TROUBLES;
  const {
    settings: { locale },
  } = getState();
  store.dispatch(actions.clearError('GET_HELP'));

  const data = await dispatch(getHelpSection({ section }));
  const { errors } = getState();
  const error = errors[PROCESSING_ITEMS.GET_HELP];
  if (data.isDisconnect) {
    return { data, section, category, locale, isDisconnect: true };
  }
  if (error) {
    if (res && (error.code === 404 || error.code === 500)) {
      res.statusCode = error.code;
    }

    return { data, section, category, locale, statusCode: error.code || 404 };
  }

  return { data, section, category, locale, statusCode: undefined, query };
};

export default HelpSection;
